import { useEffectOnce } from 'react-use'

import { webRoutes } from '@local/utils'

import Loading from '@web/components/Loading'
import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import { useNavigation } from '@web/hooks/useNavigation'
import { neloLogger } from '@web/libs/utils'

const HomeTabPage = () => {
  const navigation = useNavigation()
  const replaceToNewMy = () => navigation.push({ url: webRoutes.HOME, replace: true })
  const { referrer, mapsReferrer, mapAppVersion } = useGlobalStaticStateContext()

  useEffectOnce(() => {
    neloLogger(
      'warn',
      `구 홈탭 my/home 으로 접근 referrer: ${referrer}, mapReferrer: ${mapsReferrer}, mapAppVersion: ${mapAppVersion}`,
    )
    replaceToNewMy()
  })

  return <Loading isPageType />
}

export default HomeTabPage
